<div class="relatives-page">
  <div class="divTable greyGridTable">
    <div class="divTableBody">
      @for (user of users; track user) {
        @if ((ageType === 'adult' && user.isAdult) || (ageType === 'young' && !user.isAdult)) {
          <div class="divTableRow">
            <div class="divTableCell">
              <b>{{user?.genderType?.name}}</b>
            </div>
            <div class="divTableCell">
              @if (user?.connectedUser && user?.connectedUser?.logo) {
                <img class="logo-img" [src]="getImage(user?.connectedUser?.logo)"/>
              }
            </div>
            <div class="divTableCell">
              @if (!user?.connectedUser?.firstName) {
                <span>-</span>
              }
              @if (user?.connectedUser?.firstName) {
                <span>{{user?.connectedUser?.lastName + ' ' + user?.connectedUser?.firstName}}</span>
              }
            </div>
            <div class="divTableCell">
              @if (user?.notConnected && user?.genderType?.id) {
                <span (click)="createConnection(user)">
                  <img src="assets/images/link-32.png" style="cursor: pointer; width: 25px;" title="{{'not_connected' | translate}}" />
                </span>
              }
              @if (user?.notConnected && !user?.genderType?.id) {
                <span (click)="editUser(user)">
                  <img src="assets/images/link-32.png" style="cursor: pointer; width: 25px;" title="{{'not_connected' | translate}}"/>
                </span>
              }
              @if (!user?.notConnected) {
                <span>
                  <img src="assets/images/link-32-green.png" style="cursor: pointer; width: 25px;" title="{{'connected_created' | translate}}"/>
                </span>
              }
            </div>
            <div class="divTableCell">
              @if (user?.representative) {
                <span (click)="editUser(user)">
                  <mat-icon style="cursor: pointer; color: #A8D788" matTooltip="{{'representative' | translate}}">escalator_warning</mat-icon>
                </span>
              }
            </div>
            <div class="divTableCell">
              @if (user?.connectedUser?.firstName) {
                <button mat-icon-button (click)="editUser(user)">
                  <mat-icon>edit</mat-icon>
                </button>
              }
              @if (user?.connectedUser?.firstName) {
                <button mat-icon-button (click)="removeUser(user.id)">
                  <mat-icon>clear</mat-icon>
                </button>
              }
            </div>
          </div>
        }
      }
      @for (user of clanUsers; track user) {
        <div class="divTableRow">
          <div class="divTableCell">
            @if (user?.genderType?.name !== 'diverse') {
              <b>{{user?.genderType?.name | translate}}</b>
            }
          </div>
          <div class="divTableCell">
            @if (user?.connectedUser && user?.connectedUser?.logo) {
              <img class="logo-img" [src]="getImage(user?.connectedUser?.logo)"/>
            }
          </div>
          <div class="divTableCell">
            @if (!user?.connectedUser?.firstName) {
              <span>-</span>
            }
            @if (user?.connectedUser?.firstName) {
              <span>{{user?.connectedUser?.lastName + ' ' + user?.connectedUser?.firstName}}</span>
            }
          </div>
          <div class="divTableCell">
            @if (user?.genderType?.name === 'father' || user?.genderType?.name === 'mother' ||
            user?.genderType?.defaultType === 'father' || user?.genderType?.defaultType === 'mother') {
              <span (click)="editUser(user)">
                <img src="assets/images/link-32.png" style="cursor: pointer; width: 25px;" title="{{'not_connected' | translate}}"/>
              </span>
            } @else if (!user?.isConnected){
              <span (click)="createConnection(user)">
                <img src="assets/images/link-32.png" style="cursor: pointer; width: 25px;" title="{{'not_connected' | translate}}"/>
              </span>
            } @else {
              <span>
                  <img src="assets/images/link-32-green.png" style="cursor: pointer; width: 25px;" title="{{'connected_created' | translate}}"/>
                </span>
            }
          </div>
          <div class="divTableCell">
            @if (user?.genderType?.name === 'father' || user?.genderType?.name === 'mother' ||
            user?.genderType?.defaultType === 'father' || user?.genderType?.defaultType === 'mother') {
              <span (click)="editUser(user)">
                <mat-icon style="cursor: pointer; color: #A8D788" matTooltip="{{'representative' | translate}}">escalator_warning</mat-icon>
              </span>
            }
          </div>
          @if (type !== 'student' || ageType === 'adult') {
          <div class="divTableCell">
              @if (user?.connectedUser?.firstName) {
                <button mat-icon-button (click)="editUser(user)">
                  <mat-icon>edit</mat-icon>
                </button>
              }
              @if (user?.connectedUser?.firstName) {
                <button mat-icon-button (click)="removeClanUser(user)">
                  <mat-icon>clear</mat-icon>
                </button>
              }
          </div>
          } @else if (!user?.isConnected) {
            <div class="divTableCell">
              <mat-icon matTooltip="{{'frontUser.autoconnection' | translate}}">info</mat-icon>
            </div>
          } @else if (user?.isConnected && user?.connection){
            <div class="divTableCell">
              <button mat-icon-button (click)="removeUser(user.connection.id)">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
